<template>
  <v-dialog v-model="dialog" max-width="350" persistent>
    <v-card>
      <v-card-title>
        <span class="title">{{ confirmationTitle }}</span>
      </v-card-title>
      <v-card-text>
        <p>{{ message }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn
            color="secondary"
            @click="handleCancel()"
        >
          <v-icon left>mdi-close</v-icon>
          {{ cancelButtonText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="handleOk()"
        >
          <v-icon left>mdi-check</v-icon>
          {{ okButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import title from "./Title.vue";

export default Vue.extend({
  name: "DialogConfirmation",
  computed: {
    title() {
      return title
    }
  },
  props: {
    confirmationTitle: {
      type: String,
      required: false,
      default: "¿Estás seguro?",
    },
    message: {
      type: String,
      required: true,
    },
    okButtonText: {
      type: String,
      required: false,
      default: "Aceptar",
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: "Cancelar",
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.dialog = false;
    },

    handleOk() {
      this.$emit("ok");
      this.dialog = false;
    },
  },
});
</script>
